import { render, staticRenderFns } from "./the-debug-bar.vue?vue&type=template&id=1d4309ae"
import script from "./the-debug-bar.vue?vue&type=script&lang=js"
export * from "./the-debug-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports